import React, { Component } from 'react';
import { sendClickLog } from './newTiaraUtil';

export default function tiaraClickSender(WrappedComponent) {
  class TiaraClickSenderComponent extends Component {
    constructor(props) {
      super(props);
    }

    componentDidMount() {
      if (window.TiaraTracker) {
        window.addEventListener('mousedown', this.onSendClickLog);
      }
    }

    componentWillUnmount() {
      if (window.TiaraTracker) {
        window.removeEventListener('mousedown', this.onSendClickLog);
      }
    }

    onSendClickLog(e) {
      const clickInfo = window.TiaraTracker.getClickInfo(e);
      if (!clickInfo) {
        return;
      }
      const { click, eventMeta } = clickInfo;;
      if (click.click_url) {
        sendClickLog(click, eventMeta);
      }
    }

    render() {
      return (
        <WrappedComponent {...this.props} />
      );
    }
  }

  return TiaraClickSenderComponent;
}



// WEBPACK FOOTER //
// ./src/utils/tiaraClickSender.js